export default "__VITE_ASSET__af9b7fe0__"